<ngx-loading-bar [color]="'green'" [diameter]="'3.7em'"></ngx-loading-bar>

<p-toast position="top-right" />

<router-outlet></router-outlet>